import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { color } from 'styles/pallete';
interface SimpleTextAreaProps {
	id?: string;
	textArea: string;
	getValue: any;
	rows?: number;
	cols?: number;
	title?: string | null;
	notice?: string | null;
	colorFont?: string;
	maxString?: number | null;
	showCountString?: boolean;
	showError?: boolean;
	errorMessage?: string;
	disable?: boolean;
	borderColor?: string;
	labelColor?: string;
	placeHolderString?: string;
}

export default function SimpleTextArea({
	id,
	textArea = '',
	getValue = function (value: any) {
		return value;
	},
	rows = 20,
	cols = 10,
	title = '',
	notice,
	colorFont = color.interface.black,
	maxString = null,
	showCountString = true,
	showError = false,
	errorMessage = '',
	disable = false,
	borderColor = color.interface.black,
	labelColor = color.interface.black,
	placeHolderString = ''
}: SimpleTextAreaProps) {
	const { t }: any = useTranslation();

	return (
		<S.container $diseable={disable}>
			<S.inputTextArea $borderColor={borderColor} $labelColor={labelColor}>
				{title !== null && <p>{title}</p>}
				{maxString === null ? (
					<textarea
						rows={rows}
						cols={cols}
						value={textArea}
						onChange={(event) => getValue(event.target.value)}
						style={{ color: colorFont }}
						data-testid={id || (title === '' ? 'simpleTextAreaTestId' : title)}
						placeholder={placeHolderString}
					></textarea>
				) : (
					<textarea
						rows={rows}
						cols={cols}
						value={textArea}
						onChange={(event) => getValue(event.target.value)}
						style={{ color: colorFont }}
						maxLength={maxString === null ? 1000 : maxString}
						data-testid={id || title}
						placeholder={placeHolderString}
					></textarea>
				)}
				{notice !== null && <span>{notice}</span>}

				{disable && <S.diseableDiv />}
			</S.inputTextArea>

			{showCountString && maxString !== null && (
				<S.maxLetters>{`${textArea.length} ${t(
					'simpleTextArea.of'
				)} ${maxString} ${t('simpleTextArea.characters')}`}</S.maxLetters>
			)}

			{showError && errorMessage !== '' && (
				<S.errorMessage>
					<p>{t(errorMessage)}</p>
				</S.errorMessage>
			)}
		</S.container>
	);
}
